var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.66659 3.16699H13.3333C14.0666 3.16699 14.6666 3.76699 14.6666 4.50033V12.5003C14.6666 13.2337 14.0666 13.8337 13.3333 13.8337H2.66659C1.93325 13.8337 1.33325 13.2337 1.33325 12.5003V4.50033C1.33325 3.76699 1.93325 3.16699 2.66659 3.16699Z",
    stroke: "#FFD700",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.6667 4.5L8.00001 9.16667L1.33334 4.5",
    stroke: "#FFD700",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMail);
export default __webpack_public_path__ + "static/media/footer_mail.013fa86346cb0f2b665597adb9e714cc.svg";
export { ForwardRef as ReactComponent };